import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { Link } from 'react-router-dom';

const About = () => {
  const benefits = [
    "Over 15 års erfaring i branchen",
    "Fokus på høj kvalitet og præcision",
    "Overholder altid aftalte tidsplaner",
    "Konkurrencedygtige priser uden skjulte gebyrer",
    "Komponerede løsninger med natur- og betonsten",
    "Garanti på alt udført arbejde"
  ];

  return (
    <section id="about" className="py-24 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Text Content */}
          <div className="order-1 md:order-1">
            <h2 className="text-orange-600 font-bold tracking-wider uppercase text-sm mb-3">Om Nielsen Brolægning</h2>
            <h3 className="text-3xl md:text-4xl font-bold text-slate-900 mb-6 leading-tight">
              Håndværk bygget på et fundament af <br />
              <span className="text-orange-600">tillid og kvalitet</span>
            </h3>
            <p className="text-slate-600 text-lg mb-8 leading-relaxed">
              Nielsen Brolægning er en enkeltmandsvirksomhed drevet af passion for det gode håndværk. Som din personlige brolægger hjælper jeg private boligejere og erhvervskunder med at skabe smukke, holdbare og gennemtænkte udearealer.
            </p>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {benefits.map((benefit, i) => (
                <div key={i} className="flex items-center gap-3">
                  <CheckCircle2 className="w-5 h-5 text-orange-600 shrink-0" />
                  <span className="text-slate-700 font-medium">{benefit}</span>
                </div>
              ))}
            </div>

            <div className="mt-10">
              <Link 
                to="/om-os" 
                className="inline-block px-8 py-4 bg-slate-900 text-white rounded-lg font-bold hover:bg-slate-800 transition-colors"
              >
                Læs mere om min historie
              </Link>
            </div>
          </div>

          {/* Image Content */}
          <div className="order-2 md:order-2">
            <div className="rounded-2xl overflow-hidden shadow-2xl w-full aspect-[4/3] md:aspect-[3/4] lg:aspect-[4/5] min-h-[400px] md:min-h-[600px] relative">
              <img 
                src="https://assets.auxodev.dk/cdn-cgi/image/width=1200,quality=85,format=auto/assets/66803e0c-9723-4cfe-96f2-7ea52c9dabed/6084cc65-aa32-4ff0-bccf-afef93ec634a.jpg" 
                alt="Professionelt udført brolægning" 
                className="w-full h-full object-cover"
              />
              
              <div className="absolute bottom-6 left-6 bg-white/90 backdrop-blur-sm p-4 rounded-xl shadow-lg hidden md:block border border-slate-100">
                <p className="text-3xl font-bold text-orange-600 mb-0.5">15+</p>
                <p className="text-slate-600 text-sm font-medium">Års erfaring</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
